import React from "react";
import { Modal, Button, Space, Tooltip } from "antd";
import { ReadOutlined, MessageOutlined, BugOutlined, FundProjectionScreenOutlined } from "@ant-design/icons";

function ContactSupportFAQ({
  open,
  onClose,
  backendBaseUrl,
  onOpenFeedback,
  onOpenBug,
}) {
  const openFAQ = () => {
    try {
      window.open(`${backendBaseUrl}/api/support/`, "_blank", "noopener,noreferrer");
    } catch { }
  };

  const openDemo = () => {
    try {
      if (typeof window !== "undefined" && typeof window.__openDemoVideo === "function") {
        window.__openDemoVideo();
        return;
      }
    } catch { }
    try {
      window.open("https://www.youtube.com/embed/DlS4MOAhLs0", "_blank", "noopener,noreferrer");
    } catch { }
  };

  return (
    <Modal
      title="Contact - Support - FAQ"
      open={open}
      rootClassName="liquid-glass-modal"
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <div>
          <strong>FAQ</strong> - Most questions are answered there.
          <div style={{ marginTop: 8 }}>
            <Button icon={<ReadOutlined />} onClick={openFAQ}>
              Open FAQ
            </Button>
          </div>
        </div>
        <div>
          <strong>Contact us</strong> - Send in‑app feedback or email us:
          <div style={{ marginTop: 8 }}>
            <Space wrap>
              <Button
                type="default"
                icon={<MessageOutlined />}
                onClick={() => {
                  try {
                    onClose && onClose();
                    onOpenFeedback && onOpenFeedback();
                  } catch { }
                }}
              >
                Send Feedback
              </Button>
              <a href="mailto:sam@simplyride.app" target="_blank" rel="noreferrer" style={{ marginLeft: 4 }}>
                sam@simplyride.app
              </a>
            </Space>
          </div>
        </div>
        <div>
          <strong>Bottom‑right</strong>: you can always <strong>report a bug</strong> and <strong>watch the demo</strong>.
          <div style={{ marginTop: 8, display: "flex", alignItems: "center", gap: 12 }}>
            <Tooltip title="Report a bug">
              <div
                onClick={() => {
                  try {
                    onClose && onClose();
                    onOpenBug && onOpenBug();
                  } catch { }
                }}
                title="Report a bug"
                style={{
                  backgroundColor: "#ffe6e6",
                  color: "#333",
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.12)",
                  cursor: "pointer",
                  fontSize: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <BugOutlined />
              </div>
            </Tooltip>
            <Tooltip title="Watch demo">
              <div
                onClick={openDemo}
                title="Watch demo"
                style={{
                  backgroundColor: "#ffffcc",
                  color: "#333",
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  cursor: "pointer",
                  fontSize: "22px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FundProjectionScreenOutlined />
              </div>
            </Tooltip>
          </div>
        </div>
        <div>
          <strong>Developer insights</strong> - Interested in how this app was built?
          <div style={{ marginTop: 8 }}>
            <Button
              icon={<ReadOutlined />}
              onClick={() => {
                try {
                  window.open("https://medium.com/@letsgeekabit/building-the-app-i-couldnt-find-a-simple-free-lightweight-solution-for-indoor-cycling-workouts-32544c12451a", "_blank", "noopener,noreferrer");
                } catch { }
              }}
            >
              Read Blog Posts
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default ContactSupportFAQ;


